import React from "react";

interface WildberriesIconProps {
  width?: string;
  height?: string;
  gradientId?: string;
  fillColor1?: string;
  fillColor2?: string;
  strokeColor?: string; // цвет рамки
}

export const WildberriesIcon: React.FC<WildberriesIconProps> = ({
  width = "20",
  height = "20",
  gradientId = "paint0_linear_7668_1045",
  fillColor1 = "#6F01FB",
  fillColor2 = "#FF49D7",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`border rounded `}
    >
      <rect width="48" height="48" rx="8" fill={`url(#${gradientId})`} />
      <path
        d="M36.3171 16.9374C34.598 16.9374 33.0455 17.4573 31.72 18.3471V10.2258H28.053V25.2033C28.053 29.7601 31.7603 33.4271 36.2969 33.4271C40.8336 33.4271 44.583 29.782 44.583 25.1612C44.583 20.5403 40.9159 16.9374 36.3171 16.9374ZM19.6754 26.2615L16.3196 17.5196H13.751L10.375 26.2615L6.99911 17.5196H2.99888L8.90311 32.8907H11.4717L15.0142 23.735L18.5769 32.8907H21.1455L27.0296 17.5196H23.0513L19.6754 26.2615ZM36.2987 29.7619C33.8126 29.7619 31.72 27.7737 31.72 25.1832C31.72 22.5926 33.6881 20.6264 36.3189 20.6264C38.9497 20.6264 40.9178 22.6768 40.9178 25.1832C40.9178 27.6895 38.8252 29.7619 36.2987 29.7619Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id={gradientId}
          x1="16.1455"
          y1="52.1455"
          x2="45.6"
          y2="3.05455"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={fillColor1} />
          <stop offset="1" stopColor={fillColor2} />
        </linearGradient>
      </defs>
    </svg>
  );
};
